import CaseStudiesPreview from '../components/home/CaseStudiesPreview';

function CaseStudies() {
  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-24 lg:px-8">
        <div className="text-center">
          <h2 className="text-base font-semibold text-[#0049ac] tracking-wide uppercase">Case Studies</h2>
          <p className="mt-2 text-3xl font-extrabold text-gray-900 sm:text-4xl lg:text-5xl">
            Success Stories
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
            See how leading brands are achieving remarkable growth in MENAP with our platform.
          </p>
        </div>

        <div>
          <CaseStudiesPreview hideTitle hideButton />
        </div>
        
        <div className="mt-16 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-extrabold text-gray-900">Ready to write your success story?</h3>
          <p className="mt-4 text-lg text-gray-500">
            Join these successful brands and accelerate your MENAP expansion today.
          </p>
          <div className="mt-8">
            <a
              href="/contact"
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full text-white bg-[#0049ac] hover:scale-105 transform transition-all duration-300 font-poppins"
            >
              Get Started
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CaseStudies;